// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

export { default } from './Dialog';



// WEBPACK FOOTER //
// ./components/Dialog/index.js